import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 搜索航班
export function queryFlights(data) {
  return request({
    url: URL.booking.airExport.queryFlights,
    method: 'post',
    data
  })
}

// 保存航班
export function saveFlight(data, params) {
  return request({
    url: URL.booking.airExport.saveFlight,
    method: 'post',
    data,
    params
  })
}

// 删除航班
export function deleteFlight(params) {
  return request({
    url: URL.booking.airExport.deleteFlight,
    method: 'delete',
    params
  })
}
